// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"295f0b47","589":"a417d3d2","891":"ce689772"}[chunkId] + ".chunk.js";
};